
export interface LastChangeTraceable {
    updatedAt: string;
}

export class LocalChangeHistory {
    pendingSteps = new Set<string>();

    resetState() {
        this.pendingSteps = new Set();
    }

    pinStep = (time: string) => {
        this.pendingSteps.add(time);
    }

    removeStep = (step: string) => {
        this.pendingSteps.delete(step);
    }

    isChangeLocal = (item: LastChangeTraceable) => {
        return this.pendingSteps.has(item.updatedAt!);
    }
}